if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;
      const isSliderEnabled = this.elements.viewer.dataset.hasSlider === 'true';
      if (!isSliderEnabled) return;
      const thumbNails = new Swiper(this.elements.thumbnails, {
        slidesPerView: 4,
        spaceBetween: 10,
        breakpoints: {
          750: {
            slidesPerView: 4,
          },          
          1024: {
            slidesPerView: 6,
          },
          1200: {
            slidesPerView: 8,
          }
        }
      })
      const mainSlider = new Swiper(this.elements.viewer, {
        autoHeight: true,
        navigation: {
          nextEl: this.elements.viewer.querySelector('.slideshow__button-next'),
          prevEl: this.elements.viewer.querySelector('.slideshow__button-prev')
        },
        thumbs: {
          swiper: thumbNails
        }
      })
      window.productSlider = {
        mainSlider,
        thumbNails,
        isSliderEnabled
      }
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      console.log(activeMedia)
      try {
        const hideVariantImages = this.elements.viewer.dataset.hideVariantImages === 'true';
        // if (hideVariantImages) {
        //   const cloneActiveMedia = activeMedia.cloneNode(true);
        //   const mediaId = activeMedia.dataset.mediaId
        //   const activeThumb = this.elements.thumbnails.querySelector(`li[data-target="${mediaId}"]`)
        //   const cloneActiveThumb = activeThumb.cloneNode(true);
        //   activeThumb.remove();
        //   activeMedia.remove();
        //   this.elements.viewer.querySelector('.product__media-list').prepend(cloneActiveMedia);
        //   this.elements.thumbnails.querySelector('.thumbnail-list').prepend(cloneActiveThumb);
        //   window.productSlider.mainSlider.update(); 
        //   window.productSlider.thumbNails.update();
        //   window.productSlider.mainSlider.update();
            
        //   return;
        // }
        const index = (parseInt(activeMedia.ariaLabel.split(' / ')[0], 10) - 1);
        window.productSlider.mainSlider.slideTo(index);
      } catch(err) {
        console.log(err);
        console.log('Something is not right in Media-gallery.js line 42! Please see the above statement in which we are splitting to get the index');
      }
      if (window.productSlider.isSliderEnabled) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
